// @hq-org/platform-wasm: the platform's client core in the browser. The kit's sync engine with the platform's features
// (chat: features/chat/client, board: features/tasks/client; assembled by platform/core/client), driven by the kit's TS
// host, so `watch`/`look`/`act` reach the same rules the cli and the mcp run.
//
//   const kit = await createPlatformKit({ origin, token, person, replica: true, storage: indexedDb(…) })
//   kit.watch("board.snapshot", null, (v) => render(v.data))
//   kit.act("board.place", { id, status, after })
// the kit's host only (not its own wasm): hq pins the kit at hq/kit
import { engineOptions, host, type Kit, type KitOptions, loader, type WasmSource } from "../../../../kit/bindings/wasm/ts/host";
import init, { deviceKey, initSync, open, reseal, seal, Kit as WasmKit } from "../pkg/platform_wasm.js";

/** Load the wasm once (the kit's loader). */
export const loadPlatformKit = loader(init, initSync);

/** A kit over the platform's assembly. */
export async function createPlatformKit(o: KitOptions & { wasm?: WasmSource }): Promise<Kit> {
	await loadPlatformKit(o.wasm);
	return host(new WasmKit(engineOptions(o)), o);
}

/** The sealed store's client half (features/secrets/client): `seal`, and a device key made (`deviceKey`), used
 *  to `open` a GET answer or `reseal` it, all inside wasm; the page keeps only the wrapped key and its secret's source. */
export async function platformSecrets(wasm?: URL | string | BufferSource | WebAssembly.Module) {
	await loadPlatformKit(wasm);
	return { deviceKey, open, reseal, seal };
}
